import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	dialogueBodyTypography: {
		alignItems: "center",
		whiteSpace: "pre-line"
	}
}))

export default useStyles
